
const defaultState = function () {
  return {
    mode: 0,
    listIndex: -1,
    currentPage: 0,
    tdLists: [],
    totalCount: 0,
    size: 10,
    isAndSearch: false,
    searchKeyword: '',
    searchConditions: {
    }
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getDefaultState: defaultState
}
